import { createGlobalStyle } from 'styled-components'

// 전역 스타일 생성
export const GlobalStyle = createGlobalStyle`
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
  color: inherit;
}

body {
  font-size: 16px;
  font-family: 'SUIT Variable', sans-serif;
  line-height: 1.5;
  color: #333;
  background-color: #F0F2F7;
}

table {
  border-collapse: collapse;
  border-spacing : 0;
}
`
